export interface IAuthenticationResponse {
  authType: typeAuthenticationEnum;
  accessToken: string;
  sessionId: string;
}

export interface IAuthenticationRequest {
  documentNumber: string;
  proposalNumber: string;
}

export enum typeAuthenticationEnum {
  SELLER_PF = 'PF',
  SELLER_PJ = 'PJ',
}
